export const setCountryName = (countryCode, countryList) => {
    const country = countryList?.find((country) => country?.countryCode === countryCode);
    if (country) {
        return country.countryName;
    }
};

export const groupCountriesByISDCode = (countryList) => {
    const groupedMap = new Map();
  
    const reverseSortedCountryList = [...countryList].sort((country1, country2) =>
      country2.countryName.localeCompare(country1.countryName)
    );
  
    reverseSortedCountryList.forEach((country) => {
      const { isdCode, countryName } = country;
  
      if (groupedMap.has(isdCode)) {
        const currentCountries = groupedMap.get(isdCode) ?? [];
        groupedMap.set(isdCode, [...currentCountries, countryName]);
      } else {
        groupedMap.set(isdCode, [countryName]);
      }
    });
  
    reverseSortedCountryList.forEach((countryData) => {
      countryData.countryName = (
        groupedMap.get(countryData.isdCode) ?? [countryData.countryName]
      ).join('/');
    });
  
    const uniqueCountryList = Array.from(
      new Set(reverseSortedCountryList.map((country) => country.isdCode))
    )
      .map((isdCode) =>
        reverseSortedCountryList.find((country) => country.isdCode === isdCode)
      )
      .filter((country) => !!country);
  
    return uniqueCountryList;
};